import { Box, Typography, Grid } from "@mui/material";
import featureimage1 from "../../Assets/featureimage1.png";
import featureimage2 from "../../Assets/featureimage2.png";
import featureimage3 from "../../Assets/featureimage3.png";
import { useState } from "react";
import { fontFamilyAll } from "../../Util/UtilColor"; // assuming this is your font

const Features = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const Styles = {
    featureBoxStyle: {
      position: "relative",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      padding: "20px",
      height: { xs: "30vh", sm: "35vh", md: "40vh" },
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      alignItems: "flex-start",
      textAlign: "start",
      color: "#fff",
      borderRadius: "0px", // clean edges, no gaps
      transition: "all 0.3s ease-in-out",
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        zIndex: 1,
        transition: "all 0.3s ease-in-out",
      },
      "& *": {
        position: "relative",
        zIndex: 2,
      },
    },
    heading: {
      fontSize: { xs: "22px", sm: "28px", md: "36px", lg: "40px" },
      fontWeight: 600,
      fontFamily: fontFamilyAll,
    },
    subText: (isVisible) => ({
      fontSize: { xs: "14px", sm: "16px", md: "18px", lg: "20px" },
      fontFamily: fontFamilyAll,
      opacity: isVisible ? 1 : 0,
      maxHeight: isVisible ? "200px" : "0",
      overflow: "hidden",
      transition: "opacity 0.5s ease-in-out, max-height 0.5s ease-in-out",
    }),
  };

  const featuresData = [
    { image: featureimage1, title: "FAST TRANSPORT" },
    { image: featureimage2, title: "SAFE FLY" },
    { image: featureimage3, title: "TIMELY DELIVERY" },
  ];

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={0}> {/* no space between cards */}
        {featuresData.map((feature, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={index}
            sx={{ p: 0 }} // remove padding
          >
            <Box
              sx={{
                ...Styles.featureBoxStyle,
                backgroundImage: `url(${feature.image})`,
              }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <Typography sx={Styles.heading}>{feature.title}</Typography>
              <Typography sx={Styles.subText(hoveredIndex === index)}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam.
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Features;
